import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { OryAuthPages } from '@ory-auth';
import { Observable, map, switchMap } from 'rxjs';

import { AuthFacade } from '@aw/prypco/state/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private authFacade = inject(AuthFacade);
  private router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> {
    return this.authFacade.stable$.pipe(
      switchMap(() => this.authFacade.authenticated$),
      map((authenticated) =>
        authenticated
          ? true
          : this.router.createUrlTree([
              '/',
              OryAuthPages.ROOT,
              OryAuthPages.LOGIN,
            ]),
      ),
    );
  }

  canLoad(): Observable<boolean | UrlTree> {
    return this.canActivate();
  }
}
